var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _defs, _g17, _defs2, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _defs3, _g26, _defs4, _g27, _g28, _g29, _g30, _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12, _animate13, _animate14, _animate15, _animate16, _animate17, _animate18, _animate19, _animate20, _animate21, _animate22, _animate23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemediationMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m6f0840g45127670",
    viewBox: "0 0 420 250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840g45127670_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840g45127670",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840j39205472_mask",
    style: {
      maskType: "alpha"
    },
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840j39205472_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840j39205472",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840j39205472_fill_path",
    d: "M0.01,0h419.98c0.00552,0 0.01,0.00448 0.01,0.01v249.98c0,0.00552 -0.00448,0.01 -0.01,0.01h-419.98c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-249.98c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fillRule: "nonzero",
    fill: "rgb(255, 218, 187)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m6f0840j39205472_mask)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840m44887488_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-146.4777,-204.9815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840m44887488",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840n69115977_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,44.4697)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840n69115977",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840n76805171_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4591,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840n76805171",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840n76805171_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840n76805171_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840n76805171ps0)",
    mask: "url(#m6f0840n76805171_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840q52518569_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,317.0849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840q52518569",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840q52518569_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840q52518569_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840q52518569ps0)",
    mask: "url(#m6f0840q52518569_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840r58727959_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,196.9657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840r58727959",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840r58727959_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840r58727959_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840r58727959ps0)",
    mask: "url(#m6f0840r58727959_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840s07032087_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.5341,257.3241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840s07032087",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840s07032087_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840s07032087_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840s07032087ps0)",
    mask: "url(#m6f0840s07032087_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840t07737766_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,66.7029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840t07737766",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840t07737766_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840t07737766_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840t07737766ps0)",
    mask: "url(#m6f0840t07737766_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840u02004496_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.5341,379.8341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840u02004496",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840u02004496_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840u02004496_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840u02004496ps0)",
    mask: "url(#m6f0840u02004496_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840v97296204_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0000017451547191471235,0.999899999998477,-0.9999999999984769,0.0000017453292520723307,662.4567,137.8496)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840v97296204",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840v97296204_stroke_path",
    d: "M0,0v662.45679",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840v97296204_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,661.45679)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -663.0568000000001,
    width: 1.7999999999999998,
    height: 1989.1704000000002,
    fill: "url(#m6f0840v97296204ps0)",
    mask: "url(#m6f0840v97296204_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840w09461266_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,92.677,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840w09461266",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840x55898785_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,187.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840x55898785",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840x55898785_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840x55898785_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0840x55898785ps0)",
    mask: "url(#m6f0840x55898785_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840y45684650_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,430.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840y45684650",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840y45684650_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840y45684650_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0840y45684650ps0)",
    mask: "url(#m6f0840y45684650_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840z88369308_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840z88369308",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840z88369308_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840z88369308_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0840z88369308ps0)",
    mask: "url(#m6f0840z88369308_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0840z98010009_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,268.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0840z98010009",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0840z98010009_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0840z98010009_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0840z98010009ps0)",
    mask: "url(#m6f0840z98010009_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841023577103_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,349.6007,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841023577103",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841023577103_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841023577103_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0841023577103ps0)",
    mask: "url(#m6f0841023577103_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841159639944_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,106.404,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841159639944",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841159639944_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841159639944_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0841159639944ps0)",
    mask: "url(#m6f0841159639944_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841295080277_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,525.1618,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841295080277",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841295080277_stroke_path",
    d: "M0,0v564.74103",
    fill: "none",
    stroke: "rgb(132, 174, 236)",
    strokeWidth: 0.3,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841295080277_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,-0.1499999999999998,1)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.3v-0.3h0.3v0.3z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0.14999999999999994,563.74103)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -0.6,
    y: -565.341,
    width: 1.7999999999999998,
    height: 1696.0230000000001,
    fill: "url(#m6f0841295080277ps0)",
    mask: "url(#m6f0841295080277_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f11ioc51546836_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,198.9777,241.4813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f11ioc51546836",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f11ioc51546836_stroke_path",
    d: "M0,60c0,0 0,-40.8799 0,-43.2c0,-2.3201 0.3915,-4.2857 1.2785,-6.4294c0.887,-2.1437 2.0008,-3.8085 3.6422,-5.4499c1.6414,-1.6414 3.3062,-2.7552 5.4499,-3.6422c2.1437,-0.887 4.1093,-1.2785 6.4294,-1.2785c2.3201,0 64.2,0 64.2,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f11ioc51546836_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -83,
    y: -62,
    width: 249,
    height: 186,
    fill: "url(#m6f11ioc51546836ps0)",
    mask: "url(#m6f11ioc51546836_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841308673767_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,280.4777,301.9813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841308673767",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841308673767_stroke_path",
    d: "M0,59.5c0,0 142.7285,0 145.0486,0c2.3201,0 4.2857,-0.3915 6.4294,-1.2785c2.1437,-0.887 3.8085,-2.0008 5.4499,-3.6422c1.6414,-1.6414 2.7552,-3.3062 3.6422,-5.4499c0.887,-2.1437 1.2785,-4.1093 1.2785,-6.4294c0,-2.3201 0,-42.7 0,-42.7",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841308673767_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -163.0486,
    y: -60.7,
    width: 489.1458,
    height: 182.10000000000002,
    fill: "url(#m6f0841308673767ps0)",
    mask: "url(#m6f0841308673767_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841403334790_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.4001,7.1709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841403334790",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841403334790_fill_path",
    d: "M26.3556,0h131.7742c14.5558,0 26.3556,11.7998 26.3556,26.3556v0c0,14.5558 -11.7998,26.3556 -26.3556,26.3556h-131.7742c-14.5558,0 -26.3556,-11.7998 -26.3556,-26.3556v0c0,-14.5558 11.7998,-26.3556 26.3556,-26.3556z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6f0841403334790_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841403334790_stroke_path",
    d: "M26.3556,0h131.7742c14.5558,0 26.3556,11.7998 26.3556,26.3556v0c0,14.5558 -11.7998,26.3556 -26.3556,26.3556h-131.7742c-14.5558,0 -26.3556,-11.7998 -26.3556,-26.3556v0c0,-14.5558 11.7998,-26.3556 26.3556,-26.3556z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6f0841403334790_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841403334790_stroke_path",
    d: "M26.3556,0h131.7742c14.5558,0 26.3556,11.7998 26.3556,26.3556v0c0,14.5558 -11.7998,26.3556 -26.3556,26.3556h-131.7742c-14.5558,0 -26.3556,-11.7998 -26.3556,-26.3556v0c0,-14.5558 11.7998,-26.3556 26.3556,-26.3556z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 0.783,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841403334790_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -185.26839999999999,
    y: -53.4942,
    width: 555.8052,
    height: 160.4826,
    fill: "url(#m6f0841403334790ps0)",
    mask: "url(#m6f0841403334790_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841437514650_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,15.661,15.5556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841437514650",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841588124565_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841588124565",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6f0841588124565_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841588124565_fill_path",
    d: "M0.01,0h21.58c0.00552,0 0.01,0.00448 0.01,0.01v21.58c0,0.00552 -0.00448,0.01 -0.01,0.01h-21.58c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-21.58c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6f0841588124565_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841m64571149_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841m64571149",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841m47164153_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,2.7116,2.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841m47164153",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841m47164153_stroke_path",
    d: "M8.08843,0c2.10225,1.85992 4.84603,2.82831 7.65,2.7c0.40823,1.38871 0.53315,2.84532 0.36731,4.28326c-0.16583,1.43794 -0.61903,2.82788 -1.33265,4.08721c-0.71362,1.25933 -1.67311,2.36237 -2.82145,3.24356c-1.14834,0.88119 -2.4621,1.52255 -3.86321,1.88597c-1.40111,-0.36342 -2.71487,-1.00478 -3.86321,-1.88597c-1.14834,-0.88119 -2.10783,-1.98422 -2.82145,-3.24356c-0.71362,-1.25933 -1.16682,-2.64927 -1.33265,-4.08721c-0.16583,-1.43794 -0.04092,-2.89455 0.36731,-4.28326c2.80398,0.12831 5.54775,-0.84008 7.65,-2.7z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841m47164153_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -18.5769,
    y: -18.599999999999998,
    width: 55.7307,
    height: 55.8,
    fill: "url(#m6f0841m47164153ps0)",
    mask: "url(#m6f0841m47164153_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841o69928742_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.9,9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841o69928742",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841o69928742_stroke_path",
    d: "M1.8,0.9c0,0.49706 -0.40294,0.9 -0.9,0.9c-0.49706,0 -0.9,-0.40294 -0.9,-0.9c0,-0.49706 0.40294,-0.9 0.9,-0.9c0.49706,0 0.9,0.40294 0.9,0.9z",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841o69928742_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -4.2,
    y: -4.2,
    width: 12.600000000000001,
    height: 12.600000000000001,
    fill: "url(#m6f0841o69928742ps0)",
    mask: "url(#m6f0841o69928742_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841o46905626_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.8,10.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841o46905626",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841o46905626_stroke_path",
    d: "M0,0v2.25",
    fill: "none",
    stroke: "rgb(255, 255, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841o46905626_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(-1.8369701987210297e-16,-1,1,-1.8369701987210297e-16,0,0)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,2.25)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -2.4,
    y: -4.65,
    width: 7.199999999999999,
    height: 13.950000000000001,
    fill: "url(#m6f0841o46905626ps0)",
    mask: "url(#m6f0841o46905626_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841615550955_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,36.1634,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841615550955",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841615550955_fill_path",
    d: "M5.40778,13l-1.92,-3.336h-1.044v3.336h-1.368v-8.34h2.88c0.64,0 1.18,0.112 1.62,0.336c0.448,0.224 0.78,0.524 0.996,0.9c0.224,0.376 0.336,0.796 0.336,1.26c0,0.544 -0.16,1.04 -0.48,1.488c-0.312,0.44 -0.796,0.74 -1.452,0.9l2.064,3.456zM2.44378,8.572h1.512c0.512,0 0.896,-0.128 1.152,-0.384c0.264,-0.256 0.396,-0.6 0.396,-1.032c0,-0.432 -0.128,-0.768 -0.384,-1.008c-0.256,-0.248 -0.644,-0.372 -1.164,-0.372h-1.512zM14.7178,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.05199c0.04,0.528 0.236,0.952 0.58799,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.70399,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.50399,-0.28 1.07999,-0.42 1.72799,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM13.2898,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.33599,0.296 -0.53599,0.7 -0.59999,1.212zM24.0681,6.28c0.52,0 0.984,0.108 1.392,0.324c0.416,0.216 0.74,0.536 0.972,0.96c0.24,0.424 0.36,0.936 0.36,1.536v3.9h-1.356v-3.696c0,-0.592 -0.148,-1.044 -0.444,-1.356c-0.296,-0.32 -0.7,-0.48 -1.212,-0.48c-0.512,0 -0.92,0.16 -1.224,0.48c-0.296,0.312 -0.444,0.764 -0.444,1.356v3.696h-1.356v-3.696c0,-0.592 -0.148,-1.044 -0.444,-1.356c-0.296,-0.32 -0.7,-0.48 -1.212,-0.48c-0.512,0 -0.92,0.16 -1.224,0.48c-0.296,0.312 -0.444,0.764 -0.444,1.356v3.696h-1.368v-6.612h1.368v0.756c0.224,-0.272 0.508,-0.484 0.852,-0.636c0.344,-0.152 0.712,-0.228 1.104,-0.228c0.528,0 1,0.112 1.416,0.336c0.416,0.224 0.736,0.548 0.96,0.972c0.2,-0.4 0.512,-0.716 0.936,-0.948c0.424,-0.24 0.88,-0.36 1.368,-0.36zM34.5928,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.052c0.04,0.528 0.236,0.952 0.588,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.704,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.504,-0.28 1.08,-0.42 1.728,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM33.1648,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.336,0.296 -0.536,0.7 -0.6,1.212zM35.4831,9.664c0,-0.664 0.136,-1.252 0.408,-1.764c0.28,-0.512 0.656,-0.908 1.128,-1.188c0.48,-0.288 1.012,-0.432 1.596,-0.432c0.432,0 0.856,0.096 1.272,0.288c0.424,0.184 0.76,0.432 1.008,0.744v-3.192h1.38v8.88h-1.38v-0.996c-0.224,0.32 -0.536,0.584 -0.936,0.792c-0.392,0.208 -0.844,0.312 -1.356,0.312c-0.576,0 -1.104,-0.144 -1.584,-0.432c-0.472,-0.296 -0.848,-0.704 -1.128,-1.224c-0.272,-0.528 -0.408,-1.124 -0.408,-1.788zM40.8951,9.688c0,-0.456 -0.096,-0.852 -0.288,-1.188c-0.184,-0.336 -0.428,-0.592 -0.732,-0.768c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.352,0 -0.68,0.088 -0.984,0.264c-0.304,0.168 -0.552,0.42 -0.744,0.756c-0.184,0.328 -0.276,0.72 -0.276,1.176c0,0.456 0.092,0.856 0.276,1.2c0.192,0.344 0.44,0.608 0.744,0.792c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.304,-0.176 0.548,-0.432 0.732,-0.768c0.192,-0.344 0.288,-0.744 0.288,-1.2zM44.7679,5.512c-0.248,0 -0.456,-0.084 -0.624,-0.252c-0.168,-0.168 -0.252,-0.376 -0.252,-0.624c0,-0.248 0.084,-0.456 0.252,-0.624c0.168,-0.168 0.376,-0.252 0.624,-0.252c0.24,0 0.444,0.084 0.612,0.252c0.168,0.168 0.252,0.376 0.252,0.624c0,0.248 -0.084,0.456 -0.252,0.624c-0.168,0.168 -0.372,0.252 -0.612,0.252zM45.4399,6.388v6.612h-1.368v-6.612zM46.7799,9.664c0,-0.664 0.136,-1.252 0.408,-1.764c0.28,-0.512 0.656,-0.908 1.128,-1.188c0.48,-0.288 1.008,-0.432 1.584,-0.432c0.52,0 0.972,0.104 1.356,0.312c0.392,0.2 0.704,0.452 0.936,0.756v-0.96h1.38v6.612h-1.38v-0.984c-0.232,0.312 -0.548,0.572 -0.948,0.78c-0.4,0.208 -0.856,0.312 -1.368,0.312c-0.568,0 -1.088,-0.144 -1.56,-0.432c-0.472,-0.296 -0.848,-0.704 -1.128,-1.224c-0.272,-0.528 -0.408,-1.124 -0.408,-1.788zM52.1919,9.688c0,-0.456 -0.096,-0.852 -0.288,-1.188c-0.184,-0.336 -0.428,-0.592 -0.732,-0.768c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.352,0 -0.68,0.088 -0.984,0.264c-0.304,0.168 -0.552,0.42 -0.744,0.756c-0.184,0.328 -0.276,0.72 -0.276,1.176c0,0.456 0.092,0.856 0.276,1.2c0.192,0.344 0.44,0.608 0.744,0.792c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.304,-0.176 0.548,-0.432 0.732,-0.768c0.192,-0.344 0.288,-0.744 0.288,-1.2zM56.9647,7.504v3.66c0,0.248 0.0561,0.428 0.1681,0.54c0.12,0.104 0.32,0.156 0.5999,0.156h0.8401v1.14h-1.0801c-0.6159,0 -1.0879,-0.144 -1.4159,-0.432c-0.3281,-0.288 -0.492,-0.756 -0.492,-1.404v-3.66h-0.7801v-1.116h0.7801v-1.644h1.3799v1.644h1.6081v1.116zM65.8936,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.052c0.04,0.528 0.236,0.952 0.588,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.704,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.504,-0.28 1.08,-0.42 1.728,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM64.4656,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.336,0.296 -0.536,0.7 -0.6,1.212zM66.7838,9.664c0,-0.664 0.136,-1.252 0.408,-1.764c0.28,-0.512 0.656,-0.908 1.128,-1.188c0.48,-0.288 1.012,-0.432 1.596,-0.432c0.432,0 0.856,0.096 1.272,0.288c0.424,0.184 0.76,0.432 1.008,0.744v-3.192h1.38v8.88h-1.38v-0.996c-0.224,0.32 -0.536,0.584 -0.936,0.792c-0.392,0.208 -0.844,0.312 -1.356,0.312c-0.576,0 -1.104,-0.144 -1.584,-0.432c-0.472,-0.296 -0.848,-0.704 -1.128,-1.224c-0.272,-0.528 -0.408,-1.124 -0.408,-1.788zM72.1958,9.688c0,-0.456 -0.096,-0.852 -0.288,-1.188c-0.184,-0.336 -0.428,-0.592 -0.732,-0.768c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.352,0 -0.68,0.088 -0.984,0.264c-0.304,0.168 -0.552,0.42 -0.744,0.756c-0.184,0.328 -0.276,0.72 -0.276,1.176c0,0.456 0.092,0.856 0.276,1.2c0.192,0.344 0.44,0.608 0.744,0.792c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.304,-0.176 0.548,-0.432 0.732,-0.768c0.192,-0.344 0.288,-0.744 0.288,-1.2zM78.0338,9.664c0,-0.664 0.136,-1.252 0.408,-1.764c0.28,-0.512 0.656,-0.908 1.128,-1.188c0.48,-0.288 1.008,-0.432 1.584,-0.432c0.52,0 0.972,0.104 1.356,0.312c0.392,0.2 0.704,0.452 0.936,0.756v-0.96h1.38v6.612h-1.38v-0.984c-0.232,0.312 -0.548,0.572 -0.948,0.78c-0.4,0.208 -0.856,0.312 -1.368,0.312c-0.568,0 -1.088,-0.144 -1.56,-0.432c-0.472,-0.296 -0.848,-0.704 -1.128,-1.224c-0.272,-0.528 -0.408,-1.124 -0.408,-1.788zM83.4458,9.688c0,-0.456 -0.096,-0.852 -0.288,-1.188c-0.184,-0.336 -0.428,-0.592 -0.732,-0.768c-0.304,-0.176 -0.632,-0.264 -0.984,-0.264c-0.352,0 -0.68,0.088 -0.984,0.264c-0.304,0.168 -0.552,0.42 -0.744,0.756c-0.184,0.328 -0.276,0.72 -0.276,1.176c0,0.456 0.092,0.856 0.276,1.2c0.192,0.344 0.44,0.608 0.744,0.792c0.312,0.176 0.64,0.264 0.984,0.264c0.352,0 0.68,-0.088 0.984,-0.264c0.304,-0.176 0.548,-0.432 0.732,-0.768c0.192,-0.344 0.288,-0.744 0.288,-1.2zM89.0227,13.108c-0.52,0 -0.988,-0.092 -1.404,-0.276c-0.408,-0.192 -0.732,-0.448 -0.972,-0.768c-0.24,-0.328 -0.368,-0.692 -0.384,-1.092h1.416c0.024,0.28 0.156,0.516 0.396,0.708c0.248,0.184 0.556,0.276 0.924,0.276c0.384,0 0.68,-0.072 0.888,-0.216c0.216,-0.152 0.324,-0.344 0.324,-0.576c0,-0.248 -0.12,-0.432 -0.36,-0.552c-0.232,-0.12 -0.604,-0.252 -1.116,-0.396c-0.496,-0.136 -0.9,-0.268 -1.212,-0.396c-0.312,-0.128 -0.584,-0.324 -0.816,-0.588c-0.224,-0.264 -0.336,-0.612 -0.336,-1.044c0,-0.352 0.104,-0.672 0.312,-0.96c0.208,-0.296 0.504,-0.528 0.888,-0.696c0.392,-0.168 0.84,-0.252 1.344,-0.252c0.752,0 1.356,0.192 1.812,0.576c0.464,0.376 0.712,0.892 0.744,1.548h-1.368c-0.024,-0.296 -0.144,-0.532 -0.36,-0.708c-0.216,-0.176 -0.508,-0.264 -0.876,-0.264c-0.36,0 -0.636,0.068 -0.828,0.204c-0.192,0.136 -0.288,0.316 -0.288,0.54c0,0.176 0.064,0.324 0.192,0.444c0.128,0.12 0.284,0.216 0.468,0.288c0.184,0.064 0.456,0.148 0.816,0.252c0.48,0.128 0.872,0.26 1.176,0.396c0.312,0.128 0.58,0.32 0.804,0.576c0.224,0.256 0.34,0.596 0.348,1.02c0,0.376 -0.104,0.712 -0.312,1.008c-0.208,0.296 -0.504,0.528 -0.888,0.696c-0.376,0.168 -0.82,0.252 -1.332,0.252zM95.4328,13.108c-0.52,0 -0.988,-0.092 -1.404,-0.276c-0.408,-0.192 -0.732,-0.448 -0.972,-0.768c-0.24,-0.328 -0.368,-0.692 -0.384,-1.092h1.416c0.024,0.28 0.156,0.516 0.396,0.708c0.248,0.184 0.556,0.276 0.924,0.276c0.384,0 0.68,-0.072 0.888,-0.216c0.216,-0.152 0.324,-0.344 0.324,-0.576c0,-0.248 -0.12,-0.432 -0.36,-0.552c-0.232,-0.12 -0.604,-0.252 -1.116,-0.396c-0.496,-0.136 -0.9,-0.268 -1.212,-0.396c-0.312,-0.128 -0.584,-0.324 -0.816,-0.588c-0.224,-0.264 -0.336,-0.612 -0.336,-1.044c0,-0.352 0.104,-0.672 0.312,-0.96c0.208,-0.296 0.504,-0.528 0.888,-0.696c0.392,-0.168 0.84,-0.252 1.344,-0.252c0.752,0 1.356,0.192 1.812,0.576c0.464,0.376 0.712,0.892 0.744,1.548h-1.368c-0.024,-0.296 -0.144,-0.532 -0.36,-0.708c-0.216,-0.176 -0.508,-0.264 -0.876,-0.264c-0.36,0 -0.636,0.068 -0.828,0.204c-0.192,0.136 -0.288,0.316 -0.288,0.54c0,0.176 0.064,0.324 0.192,0.444c0.128,0.12 0.284,0.216 0.468,0.288c0.184,0.064 0.456,0.148 0.816,0.252c0.48,0.128 0.872,0.26 1.176,0.396c0.312,0.128 0.58,0.32 0.804,0.576c0.224,0.256 0.34,0.596 0.348,1.02c0,0.376 -0.104,0.712 -0.312,1.008c-0.208,0.296 -0.504,0.528 -0.888,0.696c-0.376,0.168 -0.82,0.252 -1.332,0.252zM105.503,9.532c0,0.248 -0.016,0.472 -0.048,0.672h-5.052c0.04,0.528 0.236,0.952 0.588,1.272c0.352,0.32 0.784,0.48 1.296,0.48c0.736,0 1.256,-0.308 1.56,-0.924h1.476c-0.2,0.608 -0.564,1.108 -1.092,1.5c-0.52,0.384 -1.168,0.576 -1.944,0.576c-0.632,0 -1.2,-0.14 -1.704,-0.42c-0.496,-0.288 -0.888,-0.688 -1.176,-1.2c-0.28,-0.52 -0.42,-1.12 -0.42,-1.8c0,-0.68 0.136,-1.276 0.408,-1.788c0.28,-0.52 0.668,-0.92 1.164,-1.2c0.504,-0.28 1.08,-0.42 1.728,-0.42c0.624,0 1.18,0.136 1.668,0.408c0.488,0.272 0.868,0.656 1.14,1.152c0.272,0.488 0.408,1.052 0.408,1.692zM104.075,9.1c-0.008,-0.504 -0.188,-0.908 -0.54,-1.212c-0.352,-0.304 -0.788,-0.456 -1.308,-0.456c-0.472,0 -0.876,0.152 -1.212,0.456c-0.336,0.296 -0.536,0.7 -0.6,1.212zM108.445,7.504v3.66c0,0.248 0.056,0.428 0.168,0.54c0.12,0.104 0.32,0.156 0.6,0.156h0.84v1.14h-1.08c-0.616,0 -1.088,-0.144 -1.416,-0.432c-0.328,-0.288 -0.492,-0.756 -0.492,-1.404v-3.66h-0.78v-1.116h0.78v-1.644h1.38v1.644h1.608v1.116zM113.714,13.108c-0.52,0 -0.988,-0.092 -1.404,-0.276c-0.408,-0.192 -0.732,-0.448 -0.972,-0.768c-0.24,-0.328 -0.368,-0.692 -0.384,-1.092h1.416c0.024,0.28 0.156,0.516 0.396,0.708c0.248,0.184 0.556,0.276 0.924,0.276c0.384,0 0.68,-0.072 0.888,-0.216c0.216,-0.152 0.324,-0.344 0.324,-0.576c0,-0.248 -0.12,-0.432 -0.36,-0.552c-0.232,-0.12 -0.604,-0.252 -1.116,-0.396c-0.496,-0.136 -0.9,-0.268 -1.212,-0.396c-0.312,-0.128 -0.584,-0.324 -0.816,-0.588c-0.224,-0.264 -0.336,-0.612 -0.336,-1.044c0,-0.352 0.104,-0.672 0.312,-0.96c0.208,-0.296 0.504,-0.528 0.888,-0.696c0.392,-0.168 0.84,-0.252 1.344,-0.252c0.752,0 1.356,0.192 1.812,0.576c0.464,0.376 0.712,0.892 0.744,1.548h-1.368c-0.024,-0.296 -0.144,-0.532 -0.36,-0.708c-0.216,-0.176 -0.508,-0.264 -0.876,-0.264c-0.36,0 -0.636,0.068 -0.828,0.204c-0.192,0.136 -0.288,0.316 -0.288,0.54c0,0.176 0.064,0.324 0.192,0.444c0.128,0.12 0.284,0.216 0.468,0.288c0.184,0.064 0.456,0.148 0.816,0.252c0.48,0.128 0.872,0.26 1.176,0.396c0.312,0.128 0.58,0.32 0.804,0.576c0.224,0.256 0.34,0.596 0.348,1.02c0,0.376 -0.104,0.712 -0.312,1.008c-0.208,0.296 -0.504,0.528 -0.888,0.696c-0.376,0.168 -0.82,0.252 -1.332,0.252z",
    fillRule: "nonzero",
    fill: "rgb(255, 255, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841b44982497_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,52.5,96.5139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841b44982497",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841b44982497_stroke_path",
    d: "M0,0c0,0 0,40.9397 0,43.2598c0,2.3201 0.3915,4.2857 1.2785,6.4294c0.887,2.1437 2.0008,3.8085 3.6422,5.4499c1.6414,1.6414 3.3062,2.7552 5.4499,3.6422c2.1437,0.887 4.1093,1.2785 6.4294,1.2785c2.3201,0 63.7,0 63.7,0",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841b44982497_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -81.7,
    y: -61.259800000000006,
    width: 245.10000000000002,
    height: 183.7794,
    fill: "url(#m6f0841b44982497ps0)",
    mask: "url(#m6f0841b44982497_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841c95052734_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,53,157.7683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841c95052734",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841c95052734_stroke_path",
    d: "M0,61.5538c0,0 304.68,0 307.0001,0c2.3201,0 4.2857,-0.3915 6.4294,-1.2785c2.1437,-0.887 3.8085,-2.0008 5.4499,-3.6422c1.6414,-1.6414 2.7552,-3.3062 3.6422,-5.4499c0.887,-2.1437 1.2785,-4.1093 1.2785,-6.4294c0,-2.3201 0,-44.7538 0,-44.7538",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841c95052734_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -325,
    y: -62.753800000000005,
    width: 975,
    height: 188.2614,
    fill: "url(#m6f0841c95052734ps0)",
    mask: "url(#m6f0841c95052734_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841d07998095_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,295.8,96.5137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841d07998095",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841d07998095_stroke_path",
    d: "M81,60.0598c0,0 -61.8799,0 -64.2,0c-2.3201,0 -4.2857,-0.3915 -6.4294,-1.2785c-2.1437,-0.887 -3.8085,-2.0008 -5.4499,-3.6422c-1.6414,-1.6414 -2.7552,-3.3062 -3.6422,-5.4499c-0.887,-2.1437 -1.2785,-4.1093 -1.2785,-6.4294c0,-2.3201 0,-43.2598 0,-43.2598",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841d07998095_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -82.2,
    y: -61.259800000000006,
    width: 246.60000000000002,
    height: 183.7794,
    fill: "url(#m6f0841d07998095ps0)",
    mask: "url(#m6f0841d07998095_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841d91238804_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,214.8001,97.4102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841d91238804",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841d91238804_stroke_path",
    d: "M0,59.5898v-59.5898",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841d91238804_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.2,
    y: -60.7898,
    width: 3.5999999999999996,
    height: 182.36939999999998,
    fill: "url(#m6f0841d91238804ps0)",
    mask: "url(#m6f0841d91238804_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841e61805115_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.4001,151.1953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841e61805115",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841e61805115_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841e88129309_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.4001,213.9443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841e88129309",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841e88129309_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841f67835453_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,128.4001,31.0752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841f67835453",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841f67835453_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841f90042442_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.4001,151.1953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841f90042442",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841f90042442_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(132, 174, 236)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841g71837822_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,209.4001,91.4336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841g71837822",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841g71837822_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(132, 174, 236)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841g73025180_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,47.4001,91.4336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841g73025180",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841g73025180_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(132, 174, 236)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841g05429451_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,276,76.4941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841g05429451",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841g05429451_fill_path",
    d: "M40.2,20.0199c0,11.057 -8.9988,20.0199 -20.1,20.0199c-11.1012,0 -20.1,-8.9629 -20.1,-20.0199c0,-11.057 8.9988,-20.0199 20.1,-20.0199c11.1012,0 20.1,8.9629 20.1,20.0199z",
    fillRule: "nonzero",
    fill: "rgb(87, 248, 118)",
    fillOpacity: 0.22,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841h66312377_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,283.2002,83.6641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841h66312377",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841h66312377_fill_path",
    d: "M25.8,12.8486c0,7.0963 -5.7753,12.8486 -12.9,12.8486c-7.1247,0 -12.9,-5.7523 -12.9,-12.8486c0,-7.0963 5.7753,-12.8486 12.9,-12.8486c7.1247,0 12.9,5.7523 12.9,12.8486z",
    fillRule: "nonzero",
    fill: "rgb(87, 248, 118)",
    fillOpacity: 0.28,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841h65180021_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,290.4001,91.4336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841h65180021",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841h65180021_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841i19824744_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,371.4001,151.1953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841i19824744",
    opacity: 0,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841i19824744_fill_path",
    d: "M10.8,5.3785c0,2.9705 -2.4176,5.3785 -5.4,5.3785c-2.9824,0 -5.4,-2.408 -5.4,-5.3785c0,-2.9705 2.4176,-5.3785 5.4,-5.3785c2.9824,0 5.4,2.408 5.4,5.3785z",
    fillRule: "nonzero",
    fill: "rgb(132, 174, 236)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841i08504279_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,84.3,119.5205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841i08504279",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841i08504279_fill_path",
    d: "M12.5498,0h84.1004c6.93106,0 12.5498,5.61874 12.5498,12.5498v0c0,6.93106 -5.61874,12.5498 -12.5498,12.5498h-84.1004c-6.93106,0 -12.5498,-5.61874 -12.5498,-12.5498v0c0,-6.93106 5.61874,-12.5498 12.5498,-12.5498z",
    fillRule: "nonzero",
    fill: "rgb(3, 105, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6f0841i08504279_stroke_clip_path",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841i08504279_stroke_path",
    d: "M12.5498,0h84.1004c6.93106,0 12.5498,5.61874 12.5498,12.5498v0c0,6.93106 -5.61874,12.5498 -12.5498,12.5498h-84.1004c-6.93106,0 -12.5498,-5.61874 -12.5498,-12.5498v0c0,-6.93106 5.61874,-12.5498 12.5498,-12.5498z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6f0841i08504279_stroke_clip_path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841i08504279_stroke_path",
    d: "M12.5498,0h84.1004c6.93106,0 12.5498,5.61874 12.5498,12.5498v0c0,6.93106 -5.61874,12.5498 -12.5498,12.5498h-84.1004c-6.93106,0 -12.5498,-5.61874 -12.5498,-12.5498v0c0,-6.93106 5.61874,-12.5498 12.5498,-12.5498z",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 0.6,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841i08504279_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -109.8,
    y: -25.6996,
    width: 329.4,
    height: 77.0988,
    fill: "url(#m6f0841i08504279ps0)",
    mask: "url(#m6f0841i08504279_gradient_mask)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841i00910016_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,14.4,5.3498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841i00910016",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "m6f0841i00910016_clipPath",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841i00910016_fill_path",
    d: "M0.01,0h14.38c0.00552,0 0.01,0.00448 0.01,0.01v14.38c0,0.00552 -0.00448,0.01 -0.01,0.01h-14.38c-0.00552,0 -0.01,-0.00448 -0.01,-0.01v-14.38c0,-0.00552 0.00448,-0.01 0.01,-0.01z",
    fill: "white",
    clipRule: "nonzero"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m6f0841i00910016_clipPath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841r07032328_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841r07032328",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null)))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841s71000864_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,3,6.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841s71000864",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841s71000864_stroke_path",
    d: "M1.2,0h6c0.66274,0 1.2,0.53726 1.2,1.2v3.6c0,0.66274 -0.53726,1.2 -1.2,1.2h-6c-0.66274,0 -1.2,-0.53726 -1.2,-1.2v-3.6c0,-0.66274 0.53726,-1.2 1.2,-1.2z",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841s71000864_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -10.8,
    y: -8.4,
    width: 32.400000000000006,
    height: 25.200000000000003,
    fill: "url(#m6f0841s71000864ps0)",
    mask: "url(#m6f0841s71000864_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841u63233729_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,6.6,9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841u63233729",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841u63233729_stroke_path",
    d: "M1.2,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6z",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841u63233729_gradient_mask"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -3.5999999999999996,
    y: -3.5999999999999996,
    width: 10.799999999999999,
    height: 10.799999999999999,
    fill: "url(#m6f0841u63233729ps0)",
    mask: "url(#m6f0841u63233729_gradient_mask)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841v28446366_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.8,1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841v28446366",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "normal"
    }
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841v28446366_stroke_path",
    d: "M0,4.8v-2.4c0,-0.63652 0.25286,-1.24697 0.70294,-1.69706c0.45009,-0.45009 1.06054,-0.70294 1.69706,-0.70294c0.63652,0 1.24697,0.25286 1.69706,0.70294c0.45009,0.45009 0.70294,1.06054 0.70294,1.69706v2.4",
    fill: "none",
    stroke: "rgb(161, 252, 255)",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0 0",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "m6f0841v28446366_gradient_mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,0,4.8)",
    fill: "rgb(255, 255, 255)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.6,0c0,-0.33137 0.26863,-0.6 0.6,-0.6c0.33137,0 0.6,0.26863 0.6,0.6c0,0.33137 -0.26863,0.6 -0.6,0.6c-0.33137,0 -0.6,-0.26863 -0.6,-0.6z",
    transform: "matrix(6.123233995736766e-17,1,-1,6.123233995736766e-17,4.8,4.8)",
    fill: "rgb(255, 255, 255)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -7.199999999999999,
    y: -7.199999999999999,
    width: 21.599999999999998,
    height: 21.599999999999998,
    fill: "url(#m6f0841v28446366ps0)",
    mask: "url(#m6f0841v28446366_gradient_mask)"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "m6f0841j20446842_translate"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,34.8,5.5498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m6f0841j20446842",
    opacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "m6f0841j20446842_fill_path",
    d: "M3.36037,10.0672c-0.4672,0 -0.8896,-0.08 -1.2672,-0.24c-0.3712,-0.16 -0.6656,-0.3904 -0.8832,-0.6912c-0.2176,-0.3008 -0.3296,-0.656 -0.336,-1.0656h1.44c0.0192,0.2752 0.1152,0.4928 0.288,0.6528c0.1792,0.16 0.4224,0.24 0.7296,0.24c0.3136,0 0.56,-0.0736 0.7392,-0.2208c0.1792,-0.1536 0.2688,-0.352 0.2688,-0.5952c0,-0.1984 -0.0608,-0.3616 -0.1824,-0.4896c-0.1216,-0.128 -0.2752,-0.2272 -0.4608,-0.2976c-0.1792,-0.0768 -0.4288,-0.16 -0.7488,-0.2496c-0.4352,-0.128 -0.7904,-0.2528 -1.0656,-0.3744c-0.2688,-0.128 -0.5024,-0.3168 -0.7008,-0.5664c-0.192,-0.256 -0.288,-0.5952 -0.288,-1.0176c0,-0.3968 0.0992,-0.7424 0.2976,-1.0368c0.1984,-0.2944 0.4768,-0.5184 0.8352,-0.672c0.3584,-0.16 0.768,-0.24 1.2288,-0.24c0.6912,0 1.2512,0.1696 1.68,0.5088c0.4352,0.3328 0.6752,0.8 0.72,1.4016h-1.4784c-0.0128,-0.2304 -0.112,-0.4192 -0.2976,-0.5664c-0.1792,-0.1536 -0.4192,-0.2304 -0.72,-0.2304c-0.2624,0 -0.4736,0.0672 -0.6336,0.2016c-0.1536,0.1344 -0.2304,0.3296 -0.2304,0.5856c0,0.1792 0.0576,0.3296 0.1728,0.4512c0.1216,0.1152 0.2688,0.2112 0.4416,0.288c0.1792,0.0704 0.4288,0.1536 0.7488,0.2496c0.4352,0.128 0.7904,0.256 1.0656,0.384c0.2752,0.128 0.512,0.32 0.7104,0.576c0.1984,0.256 0.2976,0.592 0.2976,1.008c0,0.3584 -0.0928,0.6912 -0.2784,0.9984c-0.1856,0.3072 -0.4576,0.5536 -0.816,0.7392c-0.3584,0.1792 -0.784,0.2688 -1.2768,0.2688zM11.8408,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.88803c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.85443,-0.2144 1.06563,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.96963,0.4896 -1.60323,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.95683,0.1088 1.35363,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM10.4488,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.24323,-0.2112 -0.54083,-0.3168 -0.89283,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM12.4762,7.3408c0,-0.5504 0.112,-1.0304 0.336,-1.44c0.224,-0.416 0.5344,-0.736 0.9312,-0.96c0.3968,-0.2304 0.8512,-0.3456 1.3632,-0.3456c0.6592,0 1.2032,0.1664 1.632,0.4992c0.4352,0.3264 0.7264,0.7872 0.8736,1.3824h-1.4496c-0.0768,-0.2304 -0.208,-0.4096 -0.3936,-0.5376c-0.1792,-0.1344 -0.4032,-0.2016 -0.672,-0.2016c-0.384,0 -0.688,0.1408 -0.912,0.4224c-0.224,0.2752 -0.336,0.6688 -0.336,1.1808c0,0.5056 0.112,0.8992 0.336,1.1808c0.224,0.2752 0.528,0.4128 0.912,0.4128c0.544,0 0.8992,-0.2432 1.0656,-0.7296h1.4496c-0.1472,0.576 -0.4384,1.0336 -0.8736,1.3728c-0.4352,0.3392 -0.9792,0.5088 -1.632,0.5088c-0.512,0 -0.9664,-0.112 -1.3632,-0.336c-0.3968,-0.2304 -0.7072,-0.5504 -0.9312,-0.96c-0.224,-0.416 -0.336,-0.8992 -0.336,-1.4496zM23.6176,4.6816v5.3184h-1.3536v-0.672c-0.1728,0.2304 -0.4,0.4128 -0.6816,0.5472c-0.2752,0.128 -0.576,0.192 -0.9024,0.192c-0.416,0 -0.784,-0.0864 -1.104,-0.2592c-0.32,-0.1792 -0.5728,-0.4384 -0.7584,-0.7776c-0.1792,-0.3456 -0.2688,-0.7552 -0.2688,-1.2288v-3.12h1.344v2.928c0,0.4224 0.1056,0.7488 0.3168,0.9792c0.2112,0.224 0.4992,0.336 0.864,0.336c0.3712,0 0.6624,-0.112 0.8736,-0.336c0.2112,-0.2304 0.3168,-0.5568 0.3168,-0.9792v-2.928zM26.2876,5.5072c0.1728,-0.2816 0.3968,-0.5024 0.672,-0.6624c0.2816,-0.16 0.6016,-0.24 0.96,-0.24v1.4112h-0.3552c-0.4224,0 -0.7424,0.0992 -0.96,0.2976c-0.2112,0.1984 -0.3168,0.544 -0.3168,1.0368v2.6496h-1.344v-5.3184h1.344zM33.7689,7.2256c0,0.192 -0.0128,0.3648 -0.0384,0.5184h-3.888c0.032,0.384 0.1664,0.6848 0.4032,0.9024c0.2368,0.2176 0.528,0.3264 0.8736,0.3264c0.4992,0 0.8544,-0.2144 1.0656,-0.6432h1.4496c-0.1536,0.512 -0.448,0.9344 -0.8832,1.2672c-0.4352,0.3264 -0.9696,0.4896 -1.6032,0.4896c-0.512,0 -0.9728,-0.112 -1.3824,-0.336c-0.4032,-0.2304 -0.72,-0.5536 -0.9504,-0.9696c-0.224,-0.416 -0.336,-0.896 -0.336,-1.44c0,-0.5504 0.112,-1.0336 0.336,-1.4496c0.224,-0.416 0.5376,-0.736 0.9408,-0.96c0.4032,-0.224 0.8672,-0.336 1.392,-0.336c0.5056,0 0.9568,0.1088 1.3536,0.3264c0.4032,0.2176 0.7136,0.528 0.9312,0.9312c0.224,0.3968 0.336,0.8544 0.336,1.3728zM32.3769,6.8416c-0.0064,-0.3456 -0.1312,-0.6208 -0.3744,-0.8256c-0.2432,-0.2112 -0.5408,-0.3168 -0.8928,-0.3168c-0.3328,0 -0.6144,0.1024 -0.8448,0.3072c-0.224,0.1984 -0.3616,0.4768 -0.4128,0.8352zM36.6918,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.512,-0.736 0.8832,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3456,0 0.6752,0.0768 0.9888,0.2304c0.3136,0.1472 0.5632,0.3456 0.7488,0.5952v-2.5248h1.3632v7.104h-1.3632v-0.7872c-0.1664,0.2624 -0.4,0.4736 -0.7008,0.6336c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3712,-0.2304 -0.6656,-0.5536 -0.8832,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM40.8774,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448zM43.198,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2385,-0.336c0.3967,0 0.7423,0.08 1.0368,0.24c0.3007,0.16 0.5407,0.3616 0.7199,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.7199,0.624c-0.3008,0.16 -0.6497,0.24 -1.0465,0.24c-0.4479,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM47.3836,7.3408c0,-0.3264 -0.064,-0.6048 -0.1919,-0.8352c-0.1281,-0.2368 -0.3008,-0.416 -0.5185,-0.5376c-0.2175,-0.128 -0.4512,-0.192 -0.7007,-0.192c-0.2497,0 -0.4801,0.0608 -0.6913,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.1919,0.5056 -0.1919,0.8256c0,0.32 0.0639,0.6016 0.1919,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6913,0.192c0.2495,0 0.4832,-0.0608 0.7007,-0.1824c0.2177,-0.128 0.3904,-0.3072 0.5185,-0.5376c0.1279,-0.2368 0.1919,-0.5184 0.1919,-0.8448zM51.6147,5.7856v2.5728c0,0.1792 0.0416,0.3104 0.1248,0.3936c0.0896,0.0768 0.2368,0.1152 0.4416,0.1152h0.624v1.1328h-0.8448c-1.1328,0 -1.6992,-0.5504 -1.6992,-1.6512v-2.5632h-0.6336v-1.104h0.6336v-1.3152h1.3536v1.3152h1.1904v1.104zM53.4262,7.3216c0,-0.5376 0.1056,-1.0144 0.3168,-1.4304c0.2176,-0.416 0.5088,-0.736 0.8736,-0.96c0.3712,-0.224 0.784,-0.336 1.2384,-0.336c0.3968,0 0.7424,0.08 1.0368,0.24c0.3008,0.16 0.5408,0.3616 0.72,0.6048v-0.7584h1.3536v5.3184h-1.3536v-0.7776c-0.1728,0.2496 -0.4128,0.4576 -0.72,0.624c-0.3008,0.16 -0.6496,0.24 -1.0464,0.24c-0.448,0 -0.8576,-0.1152 -1.2288,-0.3456c-0.3648,-0.2304 -0.656,-0.5536 -0.8736,-0.9696c-0.2112,-0.4224 -0.3168,-0.9056 -0.3168,-1.4496zM57.6118,7.3408c0,-0.3264 -0.064,-0.6048 -0.192,-0.8352c-0.128,-0.2368 -0.3008,-0.416 -0.5184,-0.5376c-0.2176,-0.128 -0.4512,-0.192 -0.7008,-0.192c-0.2496,0 -0.48,0.0608 -0.6912,0.1824c-0.2112,0.1216 -0.384,0.3008 -0.5184,0.5376c-0.128,0.2304 -0.192,0.5056 -0.192,0.8256c0,0.32 0.064,0.6016 0.192,0.8448c0.1344,0.2368 0.3072,0.4192 0.5184,0.5472c0.2176,0.128 0.448,0.192 0.6912,0.192c0.2496,0 0.4832,-0.0608 0.7008,-0.1824c0.2176,-0.128 0.3904,-0.3072 0.5184,-0.5376c0.128,-0.2368 0.192,-0.5184 0.192,-0.8448z",
    fillRule: "nonzero",
    fill: "rgb(161, 252, 255)",
    fillOpacity: 1,
    style: {
      mixBlendMode: "normal"
    }
  }))))))))))))))))), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f11ioc51546836_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 135.1419;0 135.1419;0 135.1419;0 135.1419;0 135.1419;0 135.1419;0 135.1419;35.2038 99.9381;113.5995 21.5424;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338;133.8039 1.338",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f11ioc51546836_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841308673767_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 216.294;0 216.294;0 216.294;9.594 206.6999;38.1191 178.1748;69.7066 146.5874;105.6414 110.6526;142.39 73.904;175.5193 40.7746;205.6934 10.6005;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415;214.1525 2.1415",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841308673767_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841403334790",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.54;0.59;1",
    keySplines: "0.55 0.53 0.15 1;0.55 0.53 0.46 0.48;0.5 0.35 0.46 0.48",
    additive: "replace",
    fill: "freeze"
  })), _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841b44982497_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 134.6973;0 134.6973;0 134.6973;16.8972 117.8001;54.7591 79.9382;97.9289 36.7684;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336;133.3637 1.3336",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841b44982497_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-133.3637;-133.3637;-133.3637;-116.4665;-78.6045;-35.4347;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841c95052734_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;0 381.9393;120.1029 261.8364;272.4627 109.4767;378.1578 3.7816;378.1578 3.7816;378.1578 3.7816;378.1578 3.7816;378.1578 3.7816",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841c95052734_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-378.1578;-258.0548;-105.6951;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841d07998095_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;0 135.2023;41.3639 93.8384;94.9361 40.2662;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386;133.8637 1.3386",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841d07998095_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-133.8637;-92.4998;-38.9275;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841d91238804_stroke_path",
    attributeName: "stroke-dasharray",
    values: "0 60.1857;0 60.1857;0 60.1857;0 60.1857;0 60.1857;0 60.1857;44.9128 15.2729;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959;59.5898 0.5959",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate13 || (_animate13 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841d91238804_stroke_path",
    attributeName: "stroke-dashoffset",
    values: "0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0;0",
    dur: "5s",
    repeatCount: "indefinite",
    keyTimes: "0;0.04;0.08;0.12;0.16;0.2;0.24;0.28;0.32;0.36;0.4;0.44;0.48;0.52;0.56;0.6;0.64;0.68;0.72;0.76;0.8;0.84;0.88;0.92;0.96;1",
    fill: "freeze"
  })), _animate14 || (_animate14 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841e61805115",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.06;0.11;1",
    keySplines: "0.56 0.52 0.15 1;0.56 0.52 0.48 0.55;0.5 0.35 0.48 0.55",
    additive: "replace",
    fill: "freeze"
  })), _animate15 || (_animate15 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841e88129309",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.83;0.87;1",
    keySplines: "0.55 0.51 0.15 1;0.55 0.51 0.43 0.51;0.5 0.35 0.43 0.51",
    additive: "replace",
    fill: "freeze"
  })), _animate16 || (_animate16 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841f67835453",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.33;0.36;1",
    keySplines: "0.51 0.44 0.15 1;0.51 0.44 0.55 0.61;0.5 0.35 0.55 0.61",
    additive: "replace",
    fill: "freeze"
  })), _animate17 || (_animate17 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841f90042442",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.2;0.23;1",
    keySplines: "0.48 0.42 0.15 1;0.48 0.42 0.5 0.62;0.5 0.35 0.5 0.62",
    additive: "replace",
    fill: "freeze"
  })), _animate18 || (_animate18 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841g71837822",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.24;0.27;1",
    keySplines: "0.5 0.35 0.15 1;0.5 0.35 0.15 1;0.5 0.35 0.15 1",
    additive: "replace",
    fill: "freeze"
  })), _animate19 || (_animate19 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841g73025180",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.23;0.27;1",
    keySplines: "0.55 0.5 0.15 1;0.55 0.5 0.46 0.57;0.5 0.35 0.46 0.57",
    additive: "replace",
    fill: "freeze"
  })), _animate20 || (_animate20 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841g05429451",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.49;0.54;1",
    keySplines: "0.55 0.52 0.15 1;0.55 0.52 0.48 0.55;0.5 0.35 0.48 0.55",
    additive: "replace",
    fill: "freeze"
  })), _animate21 || (_animate21 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841h66312377",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.42;0.48;1",
    keySplines: "0.53 0.48 0.15 1;0.53 0.48 0.49 0.61;0.5 0.35 0.49 0.61",
    additive: "replace",
    fill: "freeze"
  })), _animate22 || (_animate22 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841h65180021",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.36;0.4;1",
    keySplines: "0.47 0.42 0.15 1;0.47 0.42 0.43 0.62;0.5 0.35 0.43 0.62",
    additive: "replace",
    fill: "freeze"
  })), _animate23 || (_animate23 = /*#__PURE__*/React.createElement("animate", {
    href: "#m6f0841i19824744",
    attributeName: "opacity",
    values: "0;0;1;1",
    dur: "5s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0;0.67;0.73;1",
    keySplines: "0.5 0.45 0.15 1;0.5 0.45 0.48 0.62;0.5 0.35 0.48 0.62",
    additive: "replace",
    fill: "freeze"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemediationMotion);
export default __webpack_public_path__ + "static/media/remediation-motion.b49e711180abdbdb5b0a8ba756edf410.svg";
export { ForwardRef as ReactComponent };